import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { currentPopup, pavilionEvent, nextPopup } from '../data/popups';
import type { PopupDay } from '../types/popup';
export function PopupLineup() {
  const p = currentPopup;
  return <section id="popups" aria-labelledby="popups-heading" className="py-20 lg:py-28 bg-foodCream" data-id="element-209" data-mp="3u45gt8p9f555">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210" data-mp="2xcge72aja1o">
        <header className="max-w-3xl mb-14" data-id="element-211" data-mp="7093a9yv5sbf">
          <h2 id="popups-heading" className="text-6xl md:text-7xl uppercase leading-[0.9] mb-4" data-id="element-212" data-mp="6z6atxlw7hte">
            Biweekly <span className="text-foodOrange" data-id="element-213" data-mp="grvalv82z78w">Pop-Ups</span>
          </h2>
          <p className="text-xl font-medium" data-id="element-214" data-mp="lpne7mi38hsx">
            Every two weekends, a new local chef takes over the Pavilion window.
            Here's who's cooking now, and what's coming.
          </p>
        </header>

        {/* Now serving — neutral frame so the vendor's own colors lead */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-16" data-id="element-215" data-mp="3h0czb0g7upmu">
          <figure className="order-2 lg:col-span-5 bg-white border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#2A1B14]" data-id="element-216" data-mp="3gy0bw7rovn2e">
            <img src={p.chefImage} alt={`${p.chef} of ${p.name} ${p.tagline}`} className="w-full aspect-square object-contain" data-id="element-217" data-mp="371x86xh6vgdc" />
            <figcaption className="border-t-4 border-foodMaroon bg-foodCard px-5 py-4 flex flex-wrap justify-between items-center gap-x-4 gap-y-1" data-id="element-218" data-mp="3lgrs52qp8gt">
              <span className="font-bold" data-id="element-219" data-mp="3ut2plh2s2gpr">{p.chef}</span>
              <a href={p.instagram.url} target="_blank" rel="noopener noreferrer" className="font-bold underline decoration-2 underline-offset-4 hover:text-foodOrange transition-colors duration-150" data-id="element-220" data-mp="3q11ehyhciw1b">
                {p.instagram.handle}
              </a>
            </figcaption>
          </figure>

          <div className="order-1 lg:col-span-7 bg-foodCard border-4 border-foodMaroon p-6 sm:p-10" data-id="element-221" data-mp="hj51cgrcwt6k">
            <div className="flex items-baseline justify-between gap-4 mb-6 pb-4 border-b-4 border-foodMaroon" data-id="element-222" data-mp="2bv6e1snu5jut">
              <h3 className="text-4xl sm:text-5xl uppercase" data-id="element-223" data-mp="223a67pvy6fde">On the Menu</h3>
              <span className="text-sm font-bold uppercase text-foodTaupe" data-id="element-224" data-mp="22163vcdp5of8">
                {p.name} · {p.dateRange}
              </span>
            </div>

            <ul className="divide-y-2 divide-foodMaroon/10" data-id="element-225" data-mp="1t2c8tqg0l63s">
              {p.platos.map(item => <li key={item.name} className="py-4 first:pt-0" data-id="element-226" data-mp="1x58md2qp6c0v">
                  <div className="flex items-baseline gap-3" data-id="element-227" data-mp="1j4efiojasj4b">
                    <span className="font-display text-2xl font-bold uppercase" data-id="element-228" data-mp="1j68yvyex836a">
                      {item.name}
                    </span>
                    <span aria-hidden="true" className="flex-1 border-b-2 border-dotted border-foodMaroon/30" data-id="element-229" data-mp="3dip3kus2j991" />
                    <span className="font-display text-2xl font-extrabold" data-id="element-230" data-mp="3if628iww960d">
                      {item.price}
                    </span>
                  </div>
                  <p className="text-foodMaroon/70 mt-1" data-id="element-231" data-mp="11weraiunl1yu">{item.description}</p>
                </li>)}
            </ul>

            <div className="mt-6 bg-foodCream border-2 border-foodMaroon p-5" data-id="element-232" data-mp="1gm2s7iyx9ym1">
              <div className="flex items-baseline justify-between gap-3 mb-2" data-id="element-233" data-mp="1brosx5h537c3">
                <span className="font-display text-2xl font-bold uppercase" data-id="element-234" data-mp="1pjd6ld71e3v6">
                  Empanadas
                </span>
                <span className="font-display text-2xl font-extrabold" data-id="element-235" data-mp="1klbkski87qg0">
                  {p.empanadas.price} each
                </span>
              </div>
              <p className="text-foodMaroon/80" data-id="element-236" data-mp="1ujhpf9vf3aok">
                {p.empanadas.flavors.join(' · ')}
              </p>
            </div>

            <p className="mt-6 text-foodTaupe font-medium" data-id="element-237" data-mp="5535r3z9adzx">{p.menuNote}</p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-238" data-mp="71mahxx4cnx">
              <a href={p.menuUrl} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 bg-foodMaroon text-foodCream px-7 py-3.5 font-bold text-lg border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#8A7A6D] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_#8A7A6D] transition-[transform,box-shadow] duration-150 ease-out" data-id="element-239" data-mp="2nefq7lnhmj36">
                View Full Menu
                <ArrowUpRight size={20} aria-hidden="true" data-id="element-240" data-mp="29m9ag0o8ye49" />
              </a>
              <a href={p.website.url} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-7 py-3.5 font-bold text-lg border-2 border-foodMaroon hover:bg-foodMaroon hover:text-foodCream transition-colors duration-150 ease-out" data-id="element-241" data-mp="2doe614y99ktj">
                {p.website.label}
              </a>
            </div>
          </div>
        </div>

        {/* Chef bio */}
        <article aria-labelledby="chef-bio-heading" className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-20" data-id="element-242" data-mp="1id6hggn6j6m2">
          <figure className="lg:col-span-5 border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#2A1B14] bg-white overflow-hidden" data-id="element-243" data-mp="19dt77lr8ee0a">
            <img src={p.chefPhoto} alt={`${p.chef}, smiling in a red chef's coat`} className="w-full aspect-[4/5] object-cover object-top" data-id="element-244" data-mp="14ezpti8tq2uu" />
          </figure>
          <div className="lg:col-span-7" data-id="element-245" data-mp="uodew1c1y0ih">
            <p className="text-sm font-bold uppercase text-foodTaupe" data-id="element-246" data-mp="pq3l9v5z77yz">
              Meet the Chef
            </p>
            <h3 id="chef-bio-heading" className="text-5xl sm:text-6xl uppercase leading-[0.9] mt-2" data-id="element-247" data-mp="lpt7vxfutfa3">
              {p.chef}
            </h3>
            <p className="font-display text-xl font-bold uppercase text-foodMaroon/70 mt-3 mb-8" data-id="element-248" data-mp="bqan5es4dpgz">
              Pimiento Kitchen · Tura, Colombia
            </p>
            <div className="space-y-5 text-lg leading-relaxed max-w-2xl" data-id="element-249" data-mp="25b4583v0i62">
              {p.bio.map((para, i) => <p key={i} className={i === 0 ? 'text-xl font-semibold' : 'text-foodMaroon/85'} data-id="element-250" data-mp="3oag3igx8elbq" data-mpi={i}>
                  {para}
                </p>)}
            </div>
          </div>
        </article>

        {/* Coming up */}
        <h3 className="text-4xl md:text-5xl uppercase mb-8" data-id="element-251" data-mp="kw27nt161ecj">
          Coming Up at the Pavilion
        </h3>
        <ol className="space-y-8" data-id="element-252" data-mp="b3whmouh56zz">
          {/* Pavilion's own event — full brand palette */}
          <li className="grid md:grid-cols-12 bg-foodMaroon text-foodCream border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#F6B303]" data-id="element-253" data-mp="b2243vlj8h5x">
            <div className="md:col-span-7 p-8 sm:p-10" data-id="element-254" data-mp="13sbrkwyr0z4g">
              <span className="inline-block -skew-x-12 bg-foodGold px-4 py-1" data-id="element-255" data-mp="13qqxf8gcji74">
                <span className="inline-block skew-x-12 text-foodMaroon text-sm font-bold uppercase tracking-wide" data-id="element-256" data-mp="18klgqas1hv5o">
                  {pavilionEvent.label}
                </span>
              </span>
              <p className="font-display text-xl font-bold uppercase text-foodCream/70 mt-5" data-id="element-257" data-mp="2oacnh9ql2w45">
                {formatDays(pavilionEvent.days)}
              </p>
              <h4 className="text-5xl md:text-6xl uppercase leading-[0.9] mt-2" data-id="element-258" data-mp="2y05zgbun1d8x">
                The Pavilion Turns <span className="text-foodGold" data-id="element-259" data-mp="2abwflfgzizkf">Two</span>
              </h4>
              <p className="text-lg text-foodCream/85 mt-4 max-w-xl" data-id="element-260" data-mp="25c0b7f4dl64c">
                {pavilionEvent.description}
              </p>
              <p className="text-sm font-semibold text-foodCream/60 mt-4" data-id="element-261" data-mp="2jcb2ukdieoqk">
                {pavilionEvent.note}
              </p>
            </div>
            <div className="md:col-span-5 min-h-[14rem] border-t-4 md:border-t-0 md:border-l-4 border-foodCream/10 overflow-hidden" data-id="element-262" data-mp="2fcamgu6uo3gv">
              <video src={pavilionEvent.video} autoPlay loop muted playsInline aria-label="The Food Pavilion logo animation" className="w-full h-full object-cover" data-id="element-263" data-mp="3qpuzalvm378y" />
            </div>
          </li>

          {/* Next vendor — deliberately muted so its brand colors don't compete */}
          <li className="grid sm:grid-cols-12 items-center gap-6 border-2 border-dashed border-foodMaroon/40 bg-foodCard p-6 sm:p-8" data-id="element-264" data-mp="22sdpkp9bq62c">
            <div className="sm:col-span-4 flex justify-center sm:justify-start" data-id="element-265" data-mp="26sns1rxwqecg">
              <img src={nextPopup.logo} alt={`${nextPopup.name} logo`} className="w-full max-w-[220px] grayscale opacity-60 mix-blend-multiply" data-id="element-266" data-mp="2bqfliqe7a8ir" />
            </div>
            <div className="sm:col-span-8" data-id="element-267" data-mp="2lo3r6bdch0fp">
              <p className="text-sm font-bold uppercase text-foodTaupe" data-id="element-268" data-mp="mduc09rv2e6v">
                Rolling in next
              </p>
              <p className="font-display text-4xl font-extrabold uppercase leading-none mt-1" data-id="element-269" data-mp="rcyll1ip6dxq">
                {nextPopup.name}
              </p>
              <p className="font-bold mt-3" data-id="element-270" data-mp="2zvqe2elrgcr1">{formatDays(nextPopup.days)}</p>
              <p className="text-foodMaroon/70 mt-1" data-id="element-271" data-mp="2ztlxaw2rjj9c">{nextPopup.note}</p>
            </div>
          </li>
        </ol>
      </div>
    </section>;
}
function formatDays(days: PopupDay[]) {
  return days.map(d => `${d.weekday} ${d.date}`).join(' · ');
}